/**
 * Created by lihanying on 2017/6/21.
 */
import { GETSCANSUCCESS } from './constants'

const initState = {}

export default function (state = initState, action) {
  switch (action.type) {
    case GETSCANSUCCESS:
      return Object.assign({}, state, { scanSuccess: action.payload })
    default:
      return state
  }
}


// WEBPACK FOOTER //
// ./src/containers/WechatAuth/reduce.js